export default function VIPCTA() {
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-background-100 via-background-100 to-primary-500/10 border border-background-200/50 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary-500/5 rounded-full -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-500/5 rounded-full translate-y-1/2 -translate-x-1/4"></div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                加入好色tv VIP会员
              </h2>
              <p className="text-sm md:text-base text-foreground-600 mb-6 leading-relaxed max-w-xl">
                畅享4K超清画质、杜比全景声、VIP专享内容、多端同步播放、去广告体验等七大特权。首月仅需9.9元，随时随地畅享影视盛宴。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <button className="px-6 py-2.5 bg-primary-500 text-white rounded-md text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer">
                  立即开通VIP
                </button>
                <button className="px-6 py-2.5 border border-background-300 text-foreground-700 rounded-md text-sm font-medium whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer">
                  了解权益
                </button>
              </div>
            </div>

            <div className="flex-shrink-0 grid grid-cols-2 gap-3 md:gap-4">
              {[
                { icon: 'ri-4k-line', label: '4K超清' },
                { icon: 'ri-surround-sound-line', label: '杜比全景声' },
                { icon: 'ri-smartphone-line', label: '多端同步' },
                { icon: 'ri-download-cloud-2-line', label: '离线下载' },
              ].map((item) => (
                <div
                  key={item.label}
                  className="flex flex-col items-center gap-2 p-3 md:p-4 rounded-lg bg-background-50/60 border border-background-200/30"
                >
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className={`${item.icon} text-xl text-accent-500`}></i>
                  </div>
                  <span className="text-xs text-foreground-600 whitespace-nowrap">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}